import Views from '../../views/host/hostRegistration/HostRegistrationViews';
import GetInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import {
  eligibilityIsComplete, meetInfoIsComplete, restrictionsIsComplete,
  sessionsIsComplete, ageGroupsIsComplete
} from './LeftNavValidation';

const getAgeGroups = (viewName, route, omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, restrictionsRoutePermission, eligibilityRoutePermission, meetInfoRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION) => {
  const isCurrent = viewName === Views.OME_MEET_AGE_GROUPS;

  const isMeetInfoComplete = meetInfoIsComplete(omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, meetInfoRoutePermission);
  const isEligibilityComplete = eligibilityIsComplete(omeMeetStateObjData, omeMeetEntryStateObjData, eligibilityRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION);
  const isRestrictionsComplete = restrictionsIsComplete(omeMeetStateObjData, restrictionsRoutePermission);
  const isSessionsComplete = sessionsIsComplete(meetStateObjData);

  const isComplete = isMeetInfoComplete === true && isEligibilityComplete === true &&
    isRestrictionsComplete === true && isSessionsComplete === true &&
    ageGroupsIsComplete(omeMeetStateObjData);

  const arePrerequisitesDone = isMeetInfoComplete === true && isEligibilityComplete === true
    && isRestrictionsComplete === true && isSessionsComplete === true;

  const item = route === '' ? GetInitialStateOmeRoute(Views.OME_MEET_AGE_GROUPS) : getInitialStateMeetRoute(Views.OME_MEET_AGE_GROUPS);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getAgeGroups;